import "reflect-metadata";
import { lazy } from "react";
import { injectable, registry } from "tsyringe";
import { FeatureSetupDef, FeatureRootRoute, FeatureSetup } from "@app/types/feature.types";
import { featurePaths } from "@feature/constants/paths.constants";
 import { version, name } from "@feature/package.json";
import { FeatureToken } from "@app/constants/di";

 const UserListPage = lazy(() => import("@feature/pages/UserList"));
 const CreateUserPage = lazy(() => import("@feature/pages/CreateUser"));

@injectable()
@registry([{ token: FeatureToken, useClass: UserList }])
class UserList implements FeatureSetupDef {
    GetFeatureSetup(): FeatureSetup {
        return {
            version,
            namespace: name,
            featuresRoot: this.features,
            permissions: [],
            index: true
        };
    }
    private readonly features: FeatureRootRoute = {
        requiredPermissions: [],
        children: [
            {
                title: "User List",
                path: featurePaths.userList,
                page: UserListPage
            },
            {
                title: "Create User",
                path: featurePaths.createUser,
                page: CreateUserPage
            },
        
        ]
    };
}
